<div class="order-addresses" [style.--color]="orderStatus === StatusEnum.Cancelled ? CancelledColor : brandColor">
  <div class="address-icon-column" *ngIf="!isExternalPickup">
    <div class="address-icon"></div>
    <div class="address-progress" [style.--encodedColor]="encodedColor" [style.height]="lineHeight + 'rem'">
      <div class="progress-line"></div>
      <div
        *ngIf="orderStatus === StatusEnum.OnItsWay || orderStatus === StatusEnum.ReceivedAtCollectionPoint"
        class="on-its-way">
        <div class="ripple" [@grow]="growState" (@grow.done)="onGrowDone()"></div>
        <div class="circle"></div>
      </div>
    </div>
    <div class="address-icon" [class.destination]="orderStatus !== StatusEnum.Delivered"></div>
  </div>
  <div class="address-column">
    <div *ngIf="!isExternalPickup" #merchantNameElement class="merchant-name">{{ senderName || merchantName }}</div>
    <div *ngIf="isExternalPickup" class="collection-title">Collection Address</div>
    <div class="dropoff-address">
      <div class="address-line-1">
        <span>{{ addressLine1 }}</span>
        <span *ngIf="dropoffAddressWasEdited" id="updated-badge">Edited</span>
      </div>
      <div *ngIf="addressLine2" class="address-line-2">{{ addressLine2 }}</div>
    </div>
  </div>
</div>
<div *ngIf="customerInstructions" id="customer-instructions">
  <div class="title">
    <span class="text">Delivery instructions</span>
    <span class="added">Added</span>
  </div>
  <div class="content">{{ customerInstructions }}</div>
</div>
